var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3C8.8545455 3 3 8.8545455 3 16L3 34C3 41.145455 8.8545455 47 16 47L34 47C41.145455 47 47 41.145455 47 34L47 16C47 8.8545455 41.145455 3 34 3L16 3zM16 5L34 5C40.054545 5 45 9.9454545 45 16L45 34C45 40.054545 40.054545 45 34 45L16 45C9.9454545 45 5 40.054545 5 34L5 16C5 9.9454545 9.9454545 5 16 5zM37 11C35.9 11 35 11.9 35 13C35 14.1 35.9 15 37 15C38.1 15 39 14.1 39 13C39 11.9 38.1 11 37 11zM25 14C18.954545 14 14 18.954545 14 25C14 31.045455 18.954545 36 25 36C31.045455 36 36 31.045455 36 25C36 18.954545 31.045455 14 25 14zM25 16C29.954545 16 34 20.045455 34 25C34 29.954545 29.954545 34 25 34C20.045455 34 16 29.954545 16 25C16 20.045455 20.045455 16 25 16z",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.f109001b84c87983ebbd244b079a1b6a.svg";
export { ForwardRef as ReactComponent };